import {Suspense} from 'react';
import {KnowledgeView} from 'views/knowledge';

export {KnowledgeGuide, KnowledgeHome} from 'views/knowledge';

export const Knowledge = () => {
  return (
    <Suspense fallback={null}>
      <KnowledgeView />
    </Suspense>
  );
};
